import Controller from './controller';

import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';

import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

const Recruit = {

	init: function() {
		this.view = {};
		if(!$('.recruit-frame').get(0)) {
			return;
		}
		this.view.accordion_header = $('.acc-header');
		this.view.accordion_header.on('click', this.accordionToggle.bind(this));

		this.view.toggle = $('.recruit-header .toggle');
		this.view.toggle.on('click', this.navToggle.bind(this));

		this.view.smoothAnchor = $('.recruit-smooth');
		this.view.smoothAnchor.on('click',this.recruitSmootAnchor.bind(this));

		Controller.view.window.on('load', this.getHashScroll.bind(this));

		this.scrollFade()
	},
	getHashScroll: function() {
		var query = document.location.search.substring(1);

		if(query == '') {

			return;
		}
		var className = query.split('=');


		var element = document.getElementsByClassName(className[1]);
		var offset = $(element).offset().top;
		$('body,html').animate({scrollTop: offset}, 300, 'swing');
	},
	stopScroll: function() {

		$(window).on('touchmove.stopscroll', function (event) {
			event.preventDefault();
		});
	},

	close: function (el) {
		$(window).off('touchmove.stopScroll');
		var top = $('body').css('top');
		top = Math.abs(parseInt(top));
		$('body').removeAttr('style');
		$('body, html').prop({ scrollTop: top });
		$('.logo .link').removeClass('is-active');
		$('.nav-toggle-text').removeClass('is-active');
		$('.recruit-nav-area').fadeOut(300);
	},
	accordionToggle: function(el) {
		$(el.currentTarget).next().slideToggle();
		$(el.currentTarget).find('.acc-toggle-mark').toggleClass('is-active');
	},
	navToggle: function(el) {
		var toggle = $(el.currentTarget);

		if (toggle.hasClass('is-active')) {//開いてる時

			toggle.removeClass('is-active');
			$('.logo .link').removeClass('is-active');
			$('.nav-toggle-text').removeClass('is-active');

			this.close();

		} else {

			toggle.addClass('is-active');
			$('.logo .link').addClass('is-active');
			$('.nav-toggle-text').addClass('is-active');

			this.stopScroll();
			this.scrollY = Controller.view.window.y;

			$('body').css({
				position: 'fixed',
				width: '100%',
				left: '0',
				top: -1 * this.scrollY,
			});
			$('.recruit-nav-area').fadeIn(300);
		}
	},
	recruitSmootAnchor: function(el) {
		this.close();
		var className = $(el.currentTarget).data('target');
		var element = document.getElementsByClassName(className);
		var offset = $(element).offset().top;
		$('body, html').animate({scrollTop: offset}, 500, 'swing');
		$('.recruit-header .toggle').removeClass('is-active');
		$('.recruit-nav-area').fadeOut()
	},
	scrollFade: function() {
		if(!$('.scroll-fade').get(0)) {
			return
		}
		var section = document.querySelectorAll('.scroll-fade-section');
		var controller = Controller.ScrollController;
		if (section.length != 0) {
			Array.prototype.slice.call(section).forEach(function (sec, index) {
				var scene = new ScrollMagic.Scene({
					triggerElement: sec,
					triggerHook: 'onCenter',
					duration: $(sec).height()
				})
				// .addIndicators( {name: "scroll"})
				.addTo(controller);
				scene.on('enter', function (event) {
					// $(sec).addClass('is-active');
					var item = $(sec).find('.scroll-fade')
					item.addClass('is-active');

				});
				scene.on('leave', function (event) {
					// $(sec).removeClass('is-active');
					var item = $(sec).find('.scroll-fade')
					item.removeClass('is-active');

				});
			});
		}
	}

}
export default Recruit
